import React, { useState } from 'react';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TR from './../../Trans';

function InfoDialog(props) {

  return (
    <BDialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div dangerouslySetInnerHTML={{ __html: props.text }}>

          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="success" onClick={props.onClose}>{TR.cm_close}</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default InfoDialog;